module.exports = __webpack_public_path__ + "static/media/link-icon.a8cd6a20.svg";